export const SELECTED_LIST_ITEM_KEY_NAME = 'selectedListItemIdx';

export const CUCON_API_KEY_NAME = 'cuconApiKey';

export const NOTIFICATION_CONDITION_ID = 'notificationConditionId';

export const PREV_PATH = 'prevPath';

export function getToken(keyName: string): string {
  return window.localStorage.getItem(keyName) as string;
}

export function setToken(keyName: string, token: string): void {
  window.localStorage.setItem(keyName, token);
}

export function clearToken(keyName: string): void {
  window.localStorage.removeItem(keyName);
}

export function clearAllKeys(): void {
  window.localStorage.clear();
}
